import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

const styles = theme => ({
  root: {
    padding: theme.spacing(1),
    width: '100%',
  },
  label: {
    cursor: 'pointer',
  },
  value: {},
  valueHidden: {
    display: 'none',
  },
});

const DataItem = ({
  className,
  classes,
  label,
  value,
}) => {
  const [hidden, setHidden] = React.useState(false);

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Typography
        className={classes.label}
        onClick={() => {
          setHidden(prev => !prev);
        }}
        weight={'bold'}
      >
        {label}
      </Typography>
      <Typography
        className={classNames(classes.value, {
          [classes.valueHidden]: hidden,
        })}
        weight={'book'}
        component={'pre'}
      >
        {`${value}`}
      </Typography>
    </Box>
  );
};

DataItem.defaultProps = {
  className: '',
  value: null,
};

DataItem.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
};

export default withStyles(styles)(DataItem);
